import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const ReplacementViewModule = new Module({
  id: 'replacement-view',
  name: 'Replacement',
  path: 'replacement',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Replacement/View'))
  ),
  actions: {
    approveReplacement: {
      id: 'approve-replacement',
      name: 'approve-replacement',
      label: 'Approve Replacement'
    },
    rejectReplacement: {
      id: 'reject-replacement',
      name: 'reject-replacement',
      label: 'Reject Replacement'
    },
    addReplacement: {
      id: 'add-replacement',
      name: 'add-replacement',
      label: 'Add Replacement'
    }
  }
});

export const ReplacementAddModule = new Module({
  id: 'replacement-add',
  name: 'ReplacementAdd',
  path: 'replacement/add',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Replacement/Form'))
  ),
  actions: {
    add: {
      id: 'add-replacement',
      name: 'add-replacement',
      label: 'Add Replacement'
    }
  }
});

const ReplacementModules = [ReplacementViewModule, ReplacementAddModule];

export default new ModuleBundle('Replacement', ReplacementModules);
